export interface IAgGridFilter {
  id :number;
  name :string;
  filters :any;
  module :string;
  createdAt :string;
  updatedAt :string;
}

export enum EAgGridFilter {
  SALES_ORDER = 'SALES_ORDER',
  STOCK = 'STOCK',
}

export enum EAgGridFilterActions {
  SET = 'set',
  EDIT = 'edit',
  DELETE = 'delete',
}
